import { render, staticRenderFns } from "./GingerGreenExtract.vue?vue&type=template&id=c7c5124e&scoped=true&"
import script from "./GingerGreenExtract.vue?vue&type=script&lang=js&"
export * from "./GingerGreenExtract.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c7c5124e",
  null
  
)

export default component.exports